module.exports = __webpack_public_path__ + "img/45000.c584f211.jpg";